import { Button, Input, Modal, Select, Space, DatePicker, message, Tabs, Upload, Row, Col, Spin, Form, Pagination } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { orderColumns } from './constants';
import "./dispatch.scss";
import FloatLabel from '../../components/FloatingLabel';
import { getUserDetails, makePostCall } from '../../utils/helper';

import dayjs from 'dayjs';
import FyzksInput from '../../components/FyzksInput';
import AgGridTable from '../../components/AgGridTable';
import { debounce } from 'lodash';
import ReportViewer from '../ReportViewer';
import { useForm } from 'antd/es/form/Form';
import { launchViewerOnDualMonitor, checkMonitorSetup } from '../../utils/MonitorManager';
import { FieldLabels } from '../../constants/fieldLabels';

const { RangePicker } = DatePicker;

const DispatchList = ({ isConsultant, StyledTabsComponent }) => {
  const [orders, setOrders] = useState({ data: [], loading: true, total: 0 });
  const [filters, setFilters] = useState({});
  // const [savedFilters, setSavedFilters] = useState([]);
  const userDetails = getUserDetails();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [refreshDisabled, setRefreshDisabled] = useState(false);
  const [viewreportModal, setViewReportModal] = useState({ visible: false, pdfData: null });
  const [receiverModal, setReceiverModal] = useState({ visible: false, details: null });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
  });

  const [receiverForm] = useForm();

  const today = dayjs();
  const yesterday = dayjs().subtract(1, 'days');

  // Set the default value to [yesterday, today]
  const [dateRange, setDateRange] = useState([yesterday, today]);
  const [printLoading, setPrintLoading] = useState(false);

  const openReport = async record => {
    if (isConsultant) {
      // window.open(`/viewer?StudyInstanceUIDs=${record?.po_study_uid}`, '_blank');
      await launchViewerOnDualMonitor(record?.po_study_uid, record);
    }
    // printReport(record)
    captureReceiver(record);
  };

  const filterResults = (tempFilters, page = 1, pageSize = 20) => {
    setOrders({ ...orders, loading: true, data: [] });
    const payload = {
      ...tempFilters,
      page: page - 1, // Backend expects 0-indexed page
      limit: pageSize,
    };

    if (dateRange) {
      payload['from_date'] = dayjs(dateRange[0]).format('YYYYMMDD');
      payload['to_date'] = dayjs(dateRange[1]).format('YYYYMMDD');
      payload['po_study_date'] = dateRange;
    }

    makePostCall('/dispatch-list', payload)
      .then(res => {
        setOrders({
          data: res.data?.data || [],
          loading: false,
          total: res.data?.total || 0,
        });
      })
      .catch(e => {
        console.log(e);
        setOrders({ data: [], loading: false, total: 0 });
      });
  };

  const handleFilterChange = (key, value) => {
    const temp_filters = { ...filters };
    temp_filters[key] = value;
    setFilters(temp_filters);
  };

  useEffect(() => {
    console.log('Filters changed', filters);
    // Reset to page 1 when filters change
    if (Object.keys(filters).length > 0 || dateRange) {
      setPagination({ current: 1, pageSize: pagination.pageSize });
    }
    debouncedFilter(filters);
  }, [filters]);

  useEffect(() => {
    console.log('date changed', filters);
    // if (Object.keys(filters).length) {
    debouncedFilter(filters);
    // }
  }, [dateRange]);

  const debouncedFilter = useCallback(
    debounce(tempFilters => {
      console.log('Debounced value:');
      // When filters change via debounce, use page 1 (already set in useEffect)
      filterResults(tempFilters, 1, pagination.pageSize);
    }, 500),
    [dateRange, pagination.pageSize]
  );

  const statusOptions =
    userDetails?.user_type === 'doc'
      ? [{ label: 'SIGNEDOFF', value: 'SIGNEDOFF' }]
      : [
          { label: 'PENDING', value: 'PENDING' },
          { label: 'SCANNED', value: 'SCANNED' },
          { label: 'DRAFTED', value: 'DRAFTED' },
          { label: 'SIGNEDOFF', value: 'SIGNEDOFF' },
        ];

  const bodyPartOptions = [
    { label: 'Head', value: 'HEAD' },
    { label: 'Brain', value: 'BRAIN' },
    { label: 'Abdomen', value: 'ABDOMEN' },
    { label: 'Chest', value: 'CHEST' },
    { label: 'Leg', value: 'LEG' },
    { label: 'Hand', value: 'HAND' },
  ];

  const siteOptions = [
    { label: 'Somajiguda', value: 'SOMAJIGUDA' },
    { label: 'HiTech City', value: 'HITEC CITY' },
    { label: 'Secunderabad', value: 'SECUNDERABAD' },
  ];

  const modalityOptions = [
    { label: 'CT', value: 'CT' },
    { label: 'Ultra Sound', value: 'US' },
    { label: 'MRI', value: 'MRI' },
    { label: 'DX', value: 'DX' },
  ];

  const captureReceiver = rec => {
    setReceiverModal({ visible: true, details: rec });
  };

  const captureAndPrint = () => {
    const receiverInfo = receiverForm.getFieldsValue();
    printReport(receiverModal?.details, receiverInfo);
  };

  const printReport = async (rec, receiverInfo) => {
    const { pacs_order } = rec;
    const { receiver_mobile, receiver_name } = receiverInfo || {};
    setReceiverModal({ visible: false });
    setPrintLoading(true);
    makePostCall(
      '/print-acc-report',
      {
        order_id: pacs_order.pacs_ord_id,
        user_id: userDetails?.username,
        fromDispatch: !isConsultant || userDetails?.user_type === 'dispatch',
        received_by: receiverInfo ? `${receiver_name} | ${receiver_mobile}` : null,
      },
      {
        responseType: 'arraybuffer',
      }
    )
      .then(async res => {
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' });

        const pdf_url = URL.createObjectURL(pdfBlob);

        setPrintLoading(false);
        const buffer = await pdfBlob.arrayBuffer();

        if (isConsultant) {
          setViewReportModal({ visible: true, pdfData: buffer, pdfBlob: pdfBlob, pdf_url });
        } else {
          // setPdfUrl(url);
          const printWindow = window.open(pdf_url, '_blank');
          printWindow.print();
        }
      })
      .catch(err => {
        console.log('Error', err);
        setPrintLoading(false);
      });
  };

  return (
    <Spin spinning={printLoading}>
      <div>
        {StyledTabsComponent && StyledTabsComponent()}
        <div style={{ padding: '0 1.25rem' }}>
          <div className="dispatch-container">
            <div className="filters-section">
              <div className="d-flex flex-wrap">
                <FloatLabel
                  label={FieldLabels.PATIENT_NAME}
                  value={filters['pat_name']}
                  className="me-3"
                >
                  <FyzksInput
                    value={filters['pat_name']}
                    onChange={e => handleFilterChange('pat_name', e.target.value)}
                  />
                </FloatLabel>

                <FloatLabel
                  label={FieldLabels.PATIENT_ID_SHORT}
                  value={filters['po_pin']}
                >
                  <FyzksInput
                    value={filters['po_pin']}
                    onChange={e => handleFilterChange('po_pin', e.target.value)}
                  />
                </FloatLabel>

                <FloatLabel
                  label="Acc. No"
                  value={filters['po_acc_no']}
                  className="me-3"
                >
                  <FyzksInput
                    value={filters['po_acc_no']}
                    width={200}
                    onChange={e => handleFilterChange('po_acc_no', e.target.value)}
                  />
                </FloatLabel>
                <FloatLabel
                  label={FieldLabels.REFERRING_DOCTOR}
                  value={filters['po_ref_doc']}
                >
                  <FyzksInput value={filters['po_ref_doc']} style={{ width: '12.5rem' }} onChange={(e) => handleFilterChange('po_ref_doc', e.target.value)} />
                </FloatLabel>

                <FloatLabel label="Study Date" value={filters['study_date']} >
                  <RangePicker style={{ width: '25rem' }} size="middle" value={dateRange} onChange={(val) => {
                    if (val) {
                      setDateRange([val[0], val[1]]);
                    } else {
                      setDateRange(null);
                    }
                  }} />
                </FloatLabel>

                <FloatLabel label="Body Part / Study Desc" value={filters['po_body_part']} >
                  <FyzksInput value={filters['po_body_part']} onChange={(e) => handleFilterChange('po_body_part', e.target.value)} />
                </FloatLabel>

                {/* <FloatLabel label="Order No" value={filters['his_ord_no']} >
                  <FyzksInput value={filters['his_ord_no']} onChange={(e) => handleFilterChange('his_ord_no', e.target.value)} />
                </FloatLabel>

                <FloatLabel label="Site" value={filters['site']} >
                  <Select value={filters['site']} allowClear style={{ width: '12.5rem' }} options={siteOptions} onChange={(val) => handleFilterChange('site', val)} />
                </FloatLabel> */}

                {/* <FloatLabel label="Status" value={filters['dispatch_status']}>
                  <Select value={filters['dispatch_status']} allowClear style={{ width: '12.5rem' }} options={statusOptions} onChange={(val) => handleFilterChange('dispatch_status', val)} />
                </FloatLabel> */}

                <FloatLabel label="Modality" value={filters['modality']} >
                  <Select allowClear value={filters['modality']} style={{ width: '12.5rem' }} options={modalityOptions} onChange={(val) => handleFilterChange('modality', val)} />
                </FloatLabel>

                <FloatLabel></FloatLabel>
              </div>
              <Button
                className="ms-3"
                type="primary"
                onClick={() => filterResults(filters)}
              >
                Search
              </Button>
              {/* <Button className='ms-3' type='primary' onClick={() => { setSaveFiltersModal({ visible: true }) }}>Save Filters</Button> */}
              {/* <Button disabled={refreshDisabled} className='!ms-auto ms-3' type='dashed' danger onClick={() => { debouncedRefresh() }} >Refresh</Button> */}
            </div>
            <div className="orders-list">
              <AgGridTable
                height="calc(100vh - 20rem)"
                loading={orders.loading}
                rowData={orders.data || []}
                rowKey={(rec) => rec?.po_acc_no ?? rec?.pacs_order?.pacs_ord_id}
                columns={orderColumns({
                  openReportEditor: openReport,
                  role: userDetails?.user_type,
                  printReport,
                  captureReceiver,
                })}
              />
              {/* External pagination for server-side paging */}
              <div className="pacs-ag-grid-pagination">
                <Pagination
                  size="small"
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={orders?.total || 0}
                  showSizeChanger
                  pageSizeOptions={['10', '20', '50', '100']}
                  onChange={(page, pageSize) => {
                    setPagination({ current: page, pageSize });
                    filterResults(filters, page, pageSize);
                  }}
                  showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`}
                />
              </div>
            </div>
          </div>
          {viewreportModal && viewreportModal?.visible && (
            <Modal
              open={viewreportModal.visible}
              onCancel={() => {
                setViewReportModal({ visible: false, pdfData: null });
              }}
              width={900}
              className="viewer-modal"
            >
              <ReportViewer
                pdfData={viewreportModal?.pdfData}
                pdfBlob={viewreportModal?.pdfBlob}
                pdf_url={viewreportModal?.pdf_url}
              />
            </Modal>
          )}
          {receiverModal && receiverModal.visible && (
            <Modal
              open={receiverModal.visible}
              onCancel={() => {
                setReceiverModal(null);
              }}
              onOk={() => {
                setReceiverModal(null);
              }}
              width={'37.5rem'}
              okButtonProps={{ style: { display: 'none' } }}
              className="receiver-modal"
            >
              <div style={{ padding: '1rem 0.5rem' }}>
                <Form
                  form={receiverForm}
                  onFinish={() => {
                    captureAndPrint();
                  }}
                >
                  <Form.Item
                    name="receiver_name"
                    label="Receiver Name"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="receiver_mobile"
                    label="Receiver Mobile"
                    rules={[
                      {
                        pattern: /^[6-9]\d{9}$/,
                        message: 'Please enter a valid 10-digit mobile number!',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item className="text-center">
                    <div>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ width: '18.75rem' }}
                      >
                        Proceed
                      </Button>
                    </div>
                    <div>
                      <Button
                        type="link"
                        onClick={() => printReport(receiverModal?.details)}
                      >
                        Continue without Info
                      </Button>
                    </div>
                  </Form.Item>
                </Form>
              </div>
            </Modal>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default DispatchList;
